import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TotalCardOrderService} from '../services/total-card-order.service';
import {Country} from '../../dto/country';
import {DocsNames} from '../../dto/docs-names';
import {SofortPaymentService} from '../services/sofort-payment.service';
import {APP_CONSTANTS} from '../../app.constants';
import {EmailValidation} from '../order/order.component';
import {TotalCardOrder} from '../../dto/total-card-order';
import {DOCUMENT} from '@angular/common';
import {CorporateForm} from '../../dto/corporate-form';
import {TotalCardCardDefinitionsModel} from '../../models/total-card-card-definitions-model';
import {TotalCardCardPinType} from '../../dto/total-card-card-pin-type';
import {environment} from '../../../environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatStepper} from '@angular/material/stepper';

declare let gtag: Function;
declare let fbq: Function;


@Component({
  selector: 'app-tankkarte',
  templateUrl: './tankkarte.component.html',
  styleUrls: ['./tankkarte.component.css']
})
export class TankkarteComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private totalCardOrderService: TotalCardOrderService,
    private sofortPaymentService: SofortPaymentService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe((e: LangChangeEvent) => {
      this.titles = this.titlesMap[e.lang];
      this.links = this.linksMap[e.lang];
      this._currentLanguage = translate.currentLang;


    });
    this._currentLanguage = translate.currentLang;


  }
  @ViewChild(MatStepper, {static: false}) matStepper: MatStepper;
  totalCardOrderForm: FormGroup;
  titlesMap = {
    de: ['Herr', 'Frau'],
    en: ['Mr', 'Mrs', 'Ms']
  };
  docsNames = DocsNames;
  linksMap = {
    de: [this.docsNames.links.license_agreement_p24.de, this.docsNames.links.terms_and_services_total.de],
    en: [this.docsNames.links.license_agreement_p24.en, this.docsNames.links.terms_and_services_total.en]
  };
  titles = this.titlesMap.en;
  links = this.linksMap.en;
  wantNews: boolean;
  nationalities: Country[];
  corporateForms: CorporateForm[];
  countries: Country[];

  cardDefinitions: TotalCardCardDefinitionsModel = null;

  maxDob = this.getMaxDateOfBirth();
  minDob = this.getMinDateOfBirth();

  summaryPageUserAddressing: any;

  isConfirmed = false;
  _currentLanguage: string;

  prefill: any;


  // Card Compact
  // googleAnalyticsCode: string = "UA-135669077-10";
  // facebookPixelId: string = "1594274527313096";

  // P24
  googleAnalyticsCode = 'UA-135669077-13';
  // facebookPixelId: string = "1594274527313096";
  // MS seit 2021-10-30
  facebookPixelId = '2849106475417611';

  productId = 9999;
  productName = 'TOTAL Card';
  productBrand = 'Total';


  isEmailValid = false;
  isCheckingEmail = false;

  public totalFormDisabled = false;

  static loadGoogleTagManager(trackingID: string): void {

    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  static loadFacebookPixel(pixelId: string): void {

    const fbScript = document.createElement('script');
    fbScript.innerText = `
     !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
    `;

    document.documentElement.firstChild.appendChild(fbScript);
  }


  ngOnInit() {

    this.document.body.classList.add('order-assistant');

    this.prefill = {
      corporateFormId: '',
      title: '',
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      dob: '',
      country: 276,
      street: '',
      building: '',
      zip: '',
      city: '',
      companyname: '',
    };

    const b = this.route.snapshot.queryParamMap.get('pf');
    if (b) {
      const j = atob(b);
      try {
        this.prefill = JSON.parse(j);
      } catch (ex) {
        // noop
      }

    }

    if (this._currentLanguage == 'de') {
      if (this.prefill.title === 'Mr') {
        this.prefill.title = 'Herr';
      } else if (this.prefill.title === 'Ms' || this.prefill.title === 'Mrs') {
        this.prefill.title = 'Frau';
      }
    }

    this.totalCardOrderService.getCorporateForms().subscribe(data => {
      this.corporateForms = data;
    });

    this.totalCardOrderService.getCardDefinitions().subscribe(data => {
      this.cardDefinitions = data;
    });

    this.totalCardOrderService.getNationalities().subscribe(data => {
      this.nationalities = data;
    });
    this.totalCardOrderService.getCountries().subscribe(countries => {
      this.countries = countries;
    });

    this.totalCardOrderForm = this.formBuilder.group(
      {
        name: this.formBuilder.group({ /*sex: "",*/
          corporateFormId: this.prefill.corporateFormId || null,
          companyName: [this.prefill.companyname || '', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(100)])],
          companyNameOnCards: ['', Validators.compose([Validators.maxLength(23)])],
          privacyPolicy: false,
          wantNews: true,
          address: [this.prefill.street || '', [Validators.pattern(APP_CONSTANTS.ADDRESS_PATTERN)]],
          building: [this.prefill.building || '', [Validators.pattern(APP_CONSTANTS.BUILDING_PATTERN)]],
          zipCode: this.prefill.zip || '',
          city: this.prefill.city || '',
          countryIsoCode: this.prefill.country || 276,
          landline: [this.prefill.landline || '', [Validators.pattern(APP_CONSTANTS.LANDLINE_PATTERN)]],
          vatid: this.prefill.vatid || '',

        }),
        contact: this.formBuilder.group({
          title: [this.prefill.title, Validators.compose([Validators.required])],
          firstName: [this.prefill.firstname || '', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
          lastName: [this.prefill.lastname || '', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
          dob: this.prefill.dob || '',
          email: [this.prefill.email || '', Validators.compose([Validators.required, Validators.email, Validators.minLength(7), Validators.maxLength(70)])],
          confirmEmail: [this.prefill.email || '', Validators.compose([Validators.required, Validators.email])],
          phone: [this.prefill.phone || ''],
        }, {
          validator: EmailValidation.MatchEmails
        }),
        requirements: this.formBuilder.group({
          cardTypes: 1,
          fuel: ['', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern(APP_CONSTANTS.FLOAT_LOCALE_AGNOSTIC)])],
          carwash: ['', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern(APP_CONSTANTS.FLOAT_LOCALE_AGNOSTIC)])],
          toll: ['', Validators.compose([Validators.required, Validators.maxLength(6), Validators.pattern(APP_CONSTANTS.FLOAT_LOCALE_AGNOSTIC)])],
        }),
        payment: this.formBuilder.group({
          iban: ['', Validators.compose([Validators.minLength(15), Validators.maxLength(31), Validators.pattern(APP_CONSTANTS.IBAN_PATTERN)])],
          bic: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(11), Validators.pattern(APP_CONSTANTS.BIC_PATTERN)])],
        }),
        cards: this.formBuilder.group({
          cards: this.formBuilder.array([]),
          companyPin: ['', Validators.compose([this.checkCompanyPin.bind(this), Validators.pattern('^[0-9]*$'), Validators.minLength(4), Validators.maxLength(4)])],
          wantInsurance: [false, Validators.compose([])]
        })
        // paymentType: this.formBuilder.group({ paymentType: "" }),
      }
    );

    this.totalCardOrderForm.get('contact.email').valueChanges.subscribe(value => {
      const control = this.totalCardOrderForm.get('contact.email');
      this.removeFormControlError(control, 'serverError');
      this.isEmailValid = false;
      this.isCheckingEmail = true;

      if ( value == null || value.trim() == '') {
        this.isEmailValid = false;
        this.isCheckingEmail = false;
        this.totalCardOrderForm.controls['contact'].patchValue({
          confirmEmail: ''
        });
        return;
      }

      this.totalCardOrderService.validateEmail(value).subscribe(data => {
        const ok = data.status === 0;
        if ( !ok ) {
          control.setErrors({
            serverError: 'email_invalid',
          });
          this.totalCardOrderForm.controls['contact'].patchValue({
            confirmEmail: ''
          });
        } else {
          this.removeFormControlError(control, 'serverError');
          this.isEmailValid = true;
        }
        this.isCheckingEmail = false;

      });

    });

    this.totalCardOrderForm.get('cards').get('cards').valueChanges.subscribe(changes => {

      let hasCompanyCode = false;

      changes.forEach((ctl) => {
        if (ctl.totalCardCardPinTypeId == 4) {
          hasCompanyCode = true;
        }
      });

      if (hasCompanyCode) {
        this.totalCardOrderForm.get('cards').get('companyPin').enable();
      } else {
        this.totalCardOrderForm.get('cards').get('companyPin').patchValue('');
        this.totalCardOrderForm.get('cards').get('companyPin').disable();
      }

      // this.totalCardOrderForm.get('cards').get('companyPin').updateValueAndValidity();

      if ((environment.production) && this.googleAnalyticsCode != null && this.googleAnalyticsCode.length > 0) {
        TankkarteComponent.loadGoogleTagManager(this.googleAnalyticsCode);
      } else {
        console.log('NO GA ' + this.googleAnalyticsCode + ' in ' + (environment.production ? 'PROD' : 'DEV'));
      }


      if ((environment.production) && this.facebookPixelId != null && this.facebookPixelId.length > 0) {
        TankkarteComponent.loadFacebookPixel(this.facebookPixelId);
      } else {
        console.log('NO FacebookPixel ' + this.facebookPixelId + ' in ' + (environment.production ? 'PROD' : 'DEV'));
      }

      const gtag_payload = {
        items: [
          {
            id: this.productId,
            name: this.productName,
            list_name: 'none',
            brand: this.productBrand,
            category: 'TC',
            variant: 'Card',
            list_position: 1,
            quantity: 1,
            price: 0,
            currency: 'EUR'
          }
        ], coupon: ''
      };

      if (typeof gtag === 'function') {
        gtag('event', 'begin_checkout', gtag_payload, );

      } else {
        console.log('not logging gtag begin_checkout ' + JSON.stringify(gtag_payload));
      }

    });

    this.addNewCard();


  }

  removeFormControlError(control: AbstractControl, errorName: string) {
    if (control.errors && control.errors[errorName]) {
      delete control.errors[errorName];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }

  checkCompanyPin(formControl: AbstractControl) {
    if (!formControl.parent) {
      return null;
    }

    let hasCompanyCode = false;

    const cards = this.totalCardOrderForm.get('cards').get('cards').value;

    cards.forEach((ctl) => {
      if (ctl.totalCardCardPinTypeId == 4) {
        hasCompanyCode = true;
      }
    });

    if (hasCompanyCode) {
      if (formControl.value != null && formControl.value.length === 4) {
        return null;
      } else {
        return {required: true};
      }
    } else {
      return null;
    }

  }

  getCardControls() {
    return this.totalCardOrderForm.get('cards').get('cards') as FormArray;
  }

  removeCard(i: number) {
    this.getCardControls().removeAt(i);
  }

  addNewCard() {

    const cardsFormArray = this.getCardControls();
    const tmp = this.formBuilder.group({
      licensePlateDriverName: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(13)])],
      totalCardCardAcceptanceId: ['', Validators.compose([Validators.required])],
      totalCardCardProductId: ['', Validators.compose([Validators.required])],
      totalCardCardServiceId: ['', Validators.compose([Validators.required])],
      totalCardCardInfoId: ['', Validators.compose([Validators.required])],
      totalCardCardPinTypeId: ['', Validators.compose([this.setPinEmpty.bind(this), Validators.required])],
      pin: ['', Validators.compose([Validators.pattern('^[0-9]*$'), Validators.minLength(4), Validators.maxLength(4)])],
      office: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(3)])],
      cardNumber: ['', Validators.compose([Validators.pattern('^[0-9]*$'), Validators.minLength(4), Validators.maxLength(4)])],
      notice: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(10)])],
      totalCardCardVehicleTypeId: ['', Validators.compose([])],
    });
    tmp.controls['pin'].disable();
    cardsFormArray.push(tmp);

  }


  setPinEmpty(formControl: AbstractControl) {
    if (!formControl.parent) {
      return null;
    }

    if (formControl.value) {
      let type: TotalCardCardPinType = null;
      this.cardDefinitions.pinTypes.forEach((e) => {
        if (e.id == formControl.value) {
          type = e;
        }
      });

      if (type != null && type.mustEnterPin && type.id != 4) {
        formControl.parent.controls['pin'].enable();
        this.totalCardOrderForm.get('cards').get('companyPin').updateValueAndValidity();
      } else {
        formControl.parent.controls['pin'].patchValue('');
        formControl.parent.controls['pin'].disable();
      }
    }


  }


  debug() {
    const cards = this.totalCardOrderForm.value.cards;
    alert('test');
  }

  getMaxDateOfBirth() {
    // This is used to prevent persons under 18 years from creating orders
    // There is an additional control in the API, consider it when changing the minimal person age.
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    maxDate.setHours(0, 0, 0, 0);
    return maxDate;
  }

  getMinDateOfBirth() {
    // MS
    // This is used to prevent persons from entering birth dates that are over 100 years ago
    // There is an additional control in the API, consider it when changing the maximum person age.
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    minDate.setHours(0, 0, 0, 0);
    return minDate;
  }

  public onStepChange(event: any): void {



    const gtag_payload = {
      items: [
        {
          id: this.productId,
          name: this.productName,
          list_name: 'none',
          brand: this.productBrand,
          category: 'TC',
          variant: 'Card',
          list_position: 1,
          quantity: 1,
          price: 0,
          currency: 'EUR'
        }
      ],
      coupon: '',
      checkout_step: event.selectedIndex
    };

    if (typeof gtag === 'function') {
      gtag('event', 'checkout_progress', gtag_payload);
    } else {
      console.log('not logging gtag checkout_progress ' + JSON.stringify(gtag_payload));
    }

  }

  getTotalCardOrderFormForm() {
    const form = this.totalCardOrderForm.value;

    const name = this.totalCardOrderForm.get('name').value;
    const contact = this.totalCardOrderForm.get('contact').value;
    const cards = this.totalCardOrderForm.get('cards').get('cards').value;
    const payment = this.totalCardOrderForm.get('payment').value;
    const requirements = this.totalCardOrderForm.get('requirements').value;
    const wantInsurance = this.totalCardOrderForm.get('cards').get('wantInsurance').value;
    const companyPin = this.totalCardOrderForm.get('cards').get('companyPin').value;

    const firstname = contact.firstName;
    const lastname = contact.lastName;
    this.summaryPageUserAddressing = {
      title: contact.title,
      firstName: firstname,
      lastName: lastname,
    };


    const x = {

      title: name.title,
      corporateFormId: name.corporateFormId,
      sex: ((name.title == 'Herr' || name.title == 'Mr') ? 'Männlich' : 'Weiblich'),
      companyName: name.companyName,
      landline: name.landline,
      address: name.address + ' ' + name.building,
      city: name.city,
      countryIsoCode: name.countryIsoCode,
      zipCode: name.zipCode,
      firstName: firstname,
      lastName: lastname,
      dob: contact.dob,

      email: contact.email,
      phone: contact.phone && contact.phone.number,

      smsConfirmationCode: contact.phone && contact.phone.confirmationCode,
      subscribeToNews: name.wantNews.toString(),
      language: this._currentLanguage,

      cardTypes: requirements.cardTypes,
      fuelInLiters: requirements.fuel,
      carwashInEuros: requirements.carwash,
      tollInEuros: requirements.toll,

      companyIban: payment.iban,
      companyBic: payment.bic,

      companyVatId: name.vatid,

      companyPin,
      wantInsurance,

      companyNameOnCards: name.companyNameOnCards,
    } as TotalCardOrder;

    if ( this._currentLanguage === 'de' ) {
      x.orderLanguage = 0;
    } else { // english
      x.orderLanguage = 1;
    }

    x.totalCardCards = cards;


    return x;
  }

  nextStep(steper) {
    steper.next();
  }

  createOrder() {
    // doesnt work
    // this.totalCardOrderForm.disable();

    if ( this.totalFormDisabled ) {
      return;
    }
    this.totalFormDisabled = true;


    const totalCardOrder = this.getTotalCardOrderFormForm();
    this.totalCardOrderService.createOrder(totalCardOrder).subscribe(
      (data: TotalCardOrder) => {

        // TODO - create externalref earlier and send to web and use this
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();

        const transaction_id = yyyy + '-' + mm + '-' + dd + '.' + Math.floor(Math.random() * 1000) + '.' + data.orderRef;

        const gtag_payload = {

          transaction_id,
          affiliation: 'CardBro',
          value: 0,
          currency: 'EUR',
          tax: 0,
          shipping: 0,

          items: [
            {
              id: this.productId,
              name: this.productName,
              list_name: 'none',
              brand: this.productBrand,
              category: 'TC',
              variant: 'Card',
              list_position: 1,
              quantity: 1,
              price: 0,
              currency: 'EUR'
            }
          ], coupon: ''
        };

        const fbpixel_payload = {
          value: 0,
          currency: 'EUR',
          contents: [
            {
              id: this.productId,
              quantity: 1
            },
          ],
          content_type: 'product'
        };


        const that = this;
        if (typeof gtag === 'function' || typeof fbq === 'function') {

          if (typeof gtag === 'function') {
            gtag('event', 'purchase', gtag_payload, );
          }

          if (typeof fbq === 'function') {
            fbq('track', 'Purchase', fbpixel_payload);
          }

          /*
          setTimeout(function(){
            that.postProcessOrder(orderForm, orderFromForm, orderFromBackend);
          }, 2000);
          */


        } else {
          console.log('not logging gtag or fbq purchase ' + JSON.stringify(gtag_payload) + '----' + JSON.stringify(fbpixel_payload));
          /*
          setTimeout(function(){
            that.postProcessOrder(orderForm, orderFromForm, orderFromBackend);
          }, 1000);
          */
        }


        this.matStepper.next();
      },
    );
  }


}
